import { Typography } from '@mui/material';
import { tagBackground, tagColor } from './tagColors';

/** Shared display-only tag styling for inventory cards and filters. */
export function TagPill({
  tag,
  variant = 'caption',
}: {
  tag: { tagId: string; name: string };
  variant?: 'caption' | 'body1';
}) {
  return (
    <Typography
      component="span"
      variant={variant}
      sx={{
        display: 'inline-block',
        color: (theme) => tagColor(tag.tagId, theme.palette.mode),
        bgcolor: (theme) => tagBackground(tag.tagId, theme.palette.mode),
        borderRadius: '999px',
        px: 0.75,
        py: 0.125,
        fontStyle: 'italic',
        fontWeight: 400,
        overflowWrap: 'anywhere',
        minWidth: 0,
        maxWidth: '100%',
      }}
    >
      {tag.name}
    </Typography>
  );
}
